
  import Events from '@/events/Events';
  import ModelItems from '@/mixins/ModelItems';
  import {JobEmploymentStatus} from '@/model/Profile';
  import LanguageSubForm from '@/components/candidate/ProfileForm/LanguageSubForm';
  import ActivitySkillsSubForm from '@/components/candidate/ProfileForm/ActivitySkillsSubForm';
  import {prepareServerSideValidationErrors} from '@/helper/FormHelper';
  export default {
    name: 'SkillsForm',
    components: {LanguageSubForm, ActivitySkillsSubForm},
    mixins: [ModelItems],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      job: {
        type: Object,
        required: false,
        default: () => {},
      },
      comeFrom: {
        type: String,
        required: false,
        default: 'detailPage',
      },
    },
    data() {
      return {
        skillsData: {
          jobEmploymentStatus: null,
          languages: [],
          firstName: '',
          lastName: '',
          gender: '',
          hasActivitySkills: null,
          activitySkills: [],
        },
        jobEmploymentStatusItems: this.prepareModelItems(JobEmploymentStatus),
        disabled: true,
        disabledButton: false,
        activitySkillsError: null,
      };
    },
    watch: {
      'skillsData.languages': function (val) {
        this.disabled = val.length === 0 ? true : false;
      },
      'skillsData.activitySkills': function () {
        if (this.activitySkillsError) {
          this.activitySkillsError = null;
        }
      },
    },
    mounted() {
      const user = this.$auth.user.candidateProfile;
      this.skillsData.jobEmploymentStatus = user.jobEmploymentStatus;
      this.skillsData.hasActivitySkills = user.hasActivitySkills;
      if (user.activitySkills && Object.keys(user.activitySkills).length > 0) {
        Object.keys(user.activitySkills).map((key) => {
          if (key != 'hydra:view') {
            this.skillsData.activitySkills.push(user.activitySkills[key]);
          }
        });
      }
      if (Object.keys(user.languages).length > 0) {
        Object.keys(user.languages).map((key) => {
          if (key != 'hydra:view') {
            this.skillsData.languages.push(user.languages[key]);
          }
        });
      }
      if (!this.skillsData.languages.length > 0) {
        this.skillsData.languages.push({
          language: '',
          level: 'language_level.native',
        });
      }
    },
    methods: {
      checkIfActivitySkills() {
        if (
          this.skillsData.hasActivitySkills &&
          this.skillsData.activitySkills.length <= 0
        ) {
          this.skillsData.activitySkills.push({activity: '', level: ''});
        }
      },
      setActivitySkillsRadio() {
        if (this.skillsData.activitySkills.length === 0) {
          this.skillsData.hasActivitySkills = false;
        }
      },
      async saveSkillsData() {
        this.disabledButton = true;
        this.skillsData.firstName = this.$auth.user.candidateProfile.firstName;
        this.skillsData.lastName = this.$auth.user.candidateProfile.lastName;
        this.skillsData.gender = this.$auth.user.candidateProfile.gender;
        if (this.skillsData.activitySkills.length > 0) {
          this.skillsData.activitySkills.forEach((item) => {
            if (item['hydra:view']) {
              delete item['hydra:view'];
            }
            return item;
          });
        }
        await this.$store
          .dispatch('api/candidateProfile/patchProfile', {
            id: this.$auth.user.candidateProfile.id,
            data: this.skillsData,
          })
          .then(() => {
            this.$emitWithClientData(
              this.comeFrom === 'AfterRegistration'
                ? Events.RegistrationBeforeApplicationStepFinished
                : Events.UpdateAndApplicationStepFinished,
              {
                jobPostingId: this.job.id,
                step: 'Skills',
              }
            );
            this.$emit('change-step');
            this.$auth.fetchUser().then(() => {
              this.$store.dispatch(
                'profileCompleteness/calculateProfileCompleteness'
              );
            });
          })
          .catch((e) => {
            if (!e.response || e.response.status !== 422) {
              throw e;
            }
            if (e.response.status === 422) {
              const violations = [];
              e.response.data.violations.map((violation) => {
                if (violation.code === '70997997-76fb-31fe-fe4a-941682389870') {
                  const vil = {
                    code: '70997997-76fb-31fe-fe4a-941682389870',
                    message: violation.message,
                    propertyPath: 'mobile',
                  };
                  violations.push(vil);
                }
                if (violation.code === '7911c98d-b845-4da0-94b7-a8dac36bc55a') {
                  this.activitySkillsError = violation.message;
                  const vil = {
                    code: '7911c98d-b845-4da0-94b7-a8dac36bc55a',
                    message: violation.message,
                    propertyPath: 'mobile',
                  };
                  violations.push(vil);
                }
              });
              e.response.data.violations = violations;
              this.$refs.form.setErrors(
                prepareServerSideValidationErrors(e.response)
              );
              if (violations[0]) {
                this.$notifications.showNotification({
                  message: violations[0].message,
                  color: 'error',
                  timeout: 5000,
                });
              }
            } else {
              this.$notifications.showNotification({
                message: this.$t('form.notification.validation_error'),
                color: 'error',
                timeout: 5000,
              });
            }
          });
        setTimeout(() => (this.disabledButton = false), 3000);
      },
    },
  };
